import http from "@/http"

const DailyManual = {
    getAllManualData: async () => {
        const all = await http.instance.get("DAI/Manual/GetAll")
          return all;
      },
      getTechnicalData: async () => {
        const all = await http.instance.get('DAI/Employee/GetAll')
            return all;
      },
      insertManual: async (data) => {
        console.log(data);
        await http.instance.post('DAI/Manual/InsertOrUpdate', data)
            .then((response) => {
                console.log (response);
            })
      },
      deleteID: async (id) => {
        await http.instance.post('DAI/Manual/DeleteById?Id=' + id)
            .then((response) => {
                console.log(response);
            })
      },
      getDataByID: async (id) => {
        const response = await http.instance.get('DAI/Manual/GetById?Id='+id)
            return response;
      }
}

export default DailyManual
